module.exports = __webpack_public_path__ + "./assets/img/step3.fd579bf1.svg";